var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.682,
    height: 17.682,
    viewBox: "0 0 17.682 17.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-2.25 -2.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M15.868,21.226H4.608A2.361,2.361,0,0,1,2.25,18.868V7.608A2.361,2.361,0,0,1,4.608,5.25h5.63a.75.75,0,0,1,0,1.5H4.608a.859.859,0,0,0-.858.858V18.868a.859.859,0,0,0,.858.858H15.868a.859.859,0,0,0,.858-.858v-5.63a.75.75,0,0,1,1.5,0v5.63A2.361,2.361,0,0,1,15.868,21.226Z",
    transform: "translate(0 -1.476)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M21.651,2.068a2.456,2.456,0,0,1,1.737,4.193l-7.64,7.64a.75.75,0,0,1-.348.2l-3.217.8a.75.75,0,0,1-.91-.91l.8-3.217a.75.75,0,0,1,.2-.348l7.64-7.64A2.44,2.44,0,0,1,21.651,2.068ZM14.833,12.693,22.327,5.2a.956.956,0,1,0-1.352-1.352l-7.493,7.493-.451,1.8Z",
    transform: "translate(-4.175 0)",
    fill: "#333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9bef1ec082701990bf4a7f9caf0bc628.svg";
export { ForwardRef as ReactComponent };